<script setup lang="ts">
	export type BadgeContext = '' | 'active' | 'pending' | 'ongoing' | 'failed' | 'expired'

	defineProps<{
		text: string
		active?: boolean
		pending?: boolean
		failed?: boolean
		ongoing?: boolean
		fill?: boolean
	}>()
</script>

<template>
	<div
		class="inline-flex items-center justify-center rounded-[20px] px-[19px] py-2 text-center capitalize"
		:class="{
			'bg-success-50 text-success-500': active && !fill,
			'bg-error-50 text-error-500': failed && !fill,
			'bg-warning-50 text-warning-500': pending && !fill,
			'bg-success-500 text-white': fill && active,
			'bg-warning-500 text-white': fill && pending,
			'bg-error-500 text-white': fill && failed,
			'bg-blue-50 text-blue-500': !fill && ongoing,
			'bg-blue-500 text-white': fill && ongoing
		}"
	>
		<slot>
			{{ text }}
		</slot>
	</div>
</template>
